import React from 'react'
import './section-button.component.css'

const SectionButton = () => {
  return (
    <button type='button' className='section-button'>Open</button>
  )
}

export default SectionButton